import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { CamAbstractInput, InputLogo, InputPanel, InputPhone, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';

import { CurrentUser } from '../dto/current-user';
import { ModifyUserPayloadInput } from '../dto/modify-user-payload-input';

export enum EMyProfileFormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  pictureDocumentId = 'pictureDocumentId',
}

@Injectable({
  providedIn: 'root',
})
export class CamMyProfileFormService {
  // Seuls ces champs sont appliques par updateCurrentUser cote back, les autres sont ignores en self-service.
  public getMyProfileForm(user: CurrentUser): CamAbstractInput[] {
    return [
      new InputPanel({
        children: [
          new InputLogo({
            class: 'col-12',
            crop: { height: 256, shape: 'circle', width: 256 },
            key: EMyProfileFormFields.pictureDocumentId,
            label: 'user.my-profile.picture',
            previewUrl: user.picture,
            value: user.pictureDocumentId,
          }),
        ],
        contentClass: 'flex-row g-space-sm',
        key: 'picturePanel',
      }),
      new InputPanel({
        children: [
          new InputTextBox({
            class: 'col-6',
            key: EMyProfileFormFields.firstName,
            label: 'user.my-profile.firstName',
            validators: [Validators.required],
            value: user.firstName,
          }),
          new InputTextBox({
            class: 'col-6',
            key: EMyProfileFormFields.lastName,
            label: 'user.my-profile.lastName',
            validators: [Validators.required],
            value: user.lastName,
          }),
        ],
        contentClass: 'flex-row g-space-sm',
        key: 'namePanel',
      }),
      new InputPanel({
        children: [
          new InputPhone({
            class: 'col-6',
            key: EMyProfileFormFields.phoneNumber,
            label: 'user.user-profile.phone',
            value: user.phoneNumber ?? '',
          }),
        ],
        contentClass: 'flex-row g-space-sm',
        key: 'phonePanel',
      }),
    ];
  }

  // `id` est ignore par updateCurrentUser mais reste requis par le schema (ModifyUserPayload.Id non nullable).
  public formatMyProfileForm(data: any, user: CurrentUser): ModifyUserPayloadInput {
    const payload: Partial<ModifyUserPayloadInput> = {
      firstName: data[EMyProfileFormFields.firstName],
      id: user.id,
      lastName: data[EMyProfileFormFields.lastName],
      phoneNumber: data[EMyProfileFormFields.phoneNumber],
      pictureDocumentId: data[EMyProfileFormFields.pictureDocumentId],
    };
    return { ...payload, ...graphQlUpdateFields(payload) };
  }
}
